import { getCustomerConfig, getTenantByHost } from '@pelicargo/tenants';
import { modelUtils } from '@pelicargo/utils';
import { useCallback, useMemo } from 'react';

import { useCustomerTheme } from './useCustomerTheme';

const { resolveCustomerCopy } = modelUtils.customerTheme;

type CustomerCopyKey = modelUtils.customerTheme.CustomerCopyKey;

/**
 * Resolves a named copy slot through DB theme -> static tenant config -> built-in default.
 *
 * Mirrors the shape of useRequestFormLabels: a memoised wrapper over a pure resolver. Returns a
 * getter rather than a materialised map so adding slots costs nothing at call sites.
 */
export const useCustomerCopy = () => {
  const theme = useCustomerTheme();
  // getCustomerConfig resolves the `as const satisfies` tenant union, which cannot be indexed
  // field-by-field directly (see packages/tenants/src/index.ts).
  const tenantCopy = useMemo(() => getCustomerConfig().copy, []);
  const tenantName = useMemo(() => getTenantByHost()?.name, []);

  return useCallback(
    (key: CustomerCopyKey) => resolveCustomerCopy(key, { db: theme?.copy, tenant: tenantCopy, tenantName }),
    [theme?.copy, tenantCopy, tenantName],
  );
};
